var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserForm',{attrs:{"user":_vm.user,"userClaims":_vm.newClaims,"userCompanies":_vm.companies,"userDepartmentAccess":_vm.departmentAccess,"userDefaultDepartment":_vm.defaultDepartment}})
}
var staticRenderFns = []

export { render, staticRenderFns }